import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { generateActivityFilters } from '../../utils';

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
var FILTERS_TO_TRANSFORM__LOWERCASE = ['products', 'eventTypes', 'objectTypes'];
var ROOT_LEVEL_FILTERS = ['actors', 'rootContainerIds'];
export var generateActivityFiltersV3 = function generateActivityFiltersV3() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return generateActivityFilters(filters, function (key, filter) {
    return Array.isArray(filter) && FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? _defineProperty({}, key, filter.map(function (f) {
      return f.toLowerCase();
    })) : _defineProperty({}, key, filter);
  }, ROOT_LEVEL_FILTERS);
};